import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=eefb505c&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefb505c",
  null
  
)

export default component.exports